import { useState } from "react";
import "../assets/css/login.css";
import { useNavigate } from "react-router-dom";
import { BOUsersController } from "../controllers/boUsersController";
import { validateLoginForm } from "../validations/loginForm";
import { Textbox } from "../components/textbox";
import { useToastPromise } from "../components/toastPromise";

export const Login = () => {
  const toastPromise = useToastPromise();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    role: "",
  });
  const [errors, setErrors] = useState({});
  const handleChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateLoginForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    toastPromise({
      promise: new Promise((resolve, reject) => {
        BOUsersController.login({
          parameters: inputs,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) =>
        `Welcome ${data.email}.\nRedirecting to home page.`,
      errorMessage: (data) => data,
      finishPromise: () => navigate("/"),
    });
  };

  return (
    <section id="login">
      <div className="login-container">
        <h3>LOGIN</h3>
        <hr />
        <form onSubmit={handleSubmit}>
          <Textbox
            type="text"
            name="email"
            placeholder="Email Address"
            value={inputs.email}
            onChange={handleChange}
            errorMsg={errors.email}
          />
          <Textbox
            type="password"
            name="password"
            placeholder="Password"
            value={inputs.password}
            onChange={handleChange}
            errorMsg={errors.password}
          />
          <input type="submit" value="Login" />
        </form>
      </div>
    </section>
  );
};
